<template>
    <div>
        <el-dialog :title="localRowData.system_name" :visible.sync="visible" width="80%" class="BorderRadius" :before-close="CloseDig" top="5vh">
            <div class="MaxHei">
                <div class="HeaderTop">
                    <div class="SearchHead">
                        <el-select  class="Wid120"size="medium" v-model="StateVal" @change="ReSetPage" clearable placeholder="状态">
                            <el-option label="已开启" :value="1"></el-option>
                            <el-option label="未开启" :value="0"></el-option>
                        </el-select>
                        <el-input class="Wid120" size="medium" placeholder="搜索" v-model="SearchVal" @keyup.enter.native="ReSetPage">
                            <i slot="suffix" class="el-input__icon el-icon-search" @click="ReSetPage"></i>
                        </el-input>
                    </div>
                    <div class="BtnHead">
                        <el-button v-throttle v-if="SeleId.length>0" class="BgColor" size="small" type="danger" @click="Delete('')">批量删除</el-button>
                        <el-button v-throttle class="BgColor" size="small" type="primary" @click="ToggleDig('Add')">新增项目</el-button>
                    </div>
                </div>
                <el-table :data="Data" border stripe style="width: 100%;" class="custom-header-table" v-loading="loading" @selection-change="SeleChange">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column prop="name" label="名称" min-width="200"></el-table-column>
                    <el-table-column prop="lxr_name" label="联系人姓名" min-width="70"></el-table-column>
                    <el-table-column prop="lxr_phone" label="联系人电话" min-width="70"></el-table-column>
                    <el-table-column prop="kv_url" label="轮播图" min-width="70">
                        <template slot-scope="scope">
                            <el-image v-if="scope.row.kv_url" :preview-src-list="[$Tools.ServeUrl()+scope.row.kv_url]" :src="$Tools.ServeUrl()+scope.row.kv_url" fit="contain"></el-image>
                        </template>
                    </el-table-column>
                    <el-table-column prop="mb_url" label="模板" min-width="70">
                        <template slot-scope="scope">
                            <div class="FuJianPos" v-for="(item,i) in scope.row.mb_url" @click="LockUrl(item.url)">附件{{ i + 1 }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="cot" label="申请限制数量" min-width="70">
                        <template slot-scope="scope">
                            <div>{{scope.row.cot?scope.row.cot:'不限制'}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="icon" label="图标" min-width="50">
                        <template slot-scope="scope">
                            <i class="iconfont" :class="scope.row.icon"></i>
                        </template>
                    </el-table-column>
                    <el-table-column prop="status" label="状态" min-width="50">
                        <template slot-scope="scope">
                            <el-switch v-model="scope.row.status" active-color="#13ce66" inactive-color="#ddd"
                            :active-value="1" :inactive-value="0" @change="ToggleSysType(scope.row)" />
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" min-width="120" align="center">
                        <template slot-scope="scope">
                            <el-tooltip effect="dark" content="编辑" placement="top-start">
                                <i class="NavIcon el-icon-edit"@click="ToggleDig(scope.row)"></i>
                            </el-tooltip>
                            <el-tooltip effect="dark" content="删除" placement="top-start">                        
                                <i class="NavIcon el-icon-delete" @click="Delete(scope.row.id)"></i>                    
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination background @size-change="SizeChange" @current-change="PageChange" :current-page="Page" layout="total,prev,pager,next,sizes" :total="Totol" hide-on-single-page></el-pagination>
            </div>
        </el-dialog>
        <el-dialog :title="Type=='Add'?'新增项目':'修改项目'" :visible.sync="NewData.blon" width="60%" top="5vh" class="BorderRadius" >
            <div class="DigItem JusCen">
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">项目名称：</div>
                    <el-input class="Wid" size="medium" placeholder="请输入项目名称" v-model="NewData.name"></el-input>
                </div>
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">联系人姓名：</div>
                    <el-input class="Wid" size="medium" placeholder="请输入联系人姓名" v-model="NewData.lxr_name"></el-input>
                </div>
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">联系人电话：</div>
                    <el-input class="Wid" size="medium" placeholder="请输入联系人电话" v-model="NewData.lxr_phone"></el-input>
                </div>
            </div>
            <div class="DigItem JusCen">
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">申请限制数量：</div>
                    <el-input class="Wid" size="medium" placeholder="请输入申请限制数量，默认为不限制" v-model="NewData.cot"></el-input>
                </div>
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">图标：</div>
                    <el-input class="Wid" size="medium" placeholder="请输入图标" v-model="NewData.icon"></el-input>
                </div>
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">部门负责人审核：</div>
                    <el-switch v-model="NewData.shenhe" active-color="#13ce66" inactive-color="#ddd" 
                        :active-value="1" :inactive-value="0"/>
                </div>
            </div>
            <div class="DigItem JusCen">
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">轮播图：</div>
                    <div>
                        <div class="ImgPos" v-if="NewData.kv_url">
                            <el-image :preview-src-list="[$Tools.ServeUrl()+NewData.kv_url]" :src="$Tools.ServeUrl()+NewData.kv_url" fit="contain"></el-image>
                            <i class="NavIcon el-icon-circle-close FuJianAbs"  @click.stop="NewData.kv_url=''"></i>
                        </div>
                        <el-upload v-else action="none" :show-file-list="false" :http-request="(res) => UploadFlie(res, 'File',)">
                            <div class="ImgPos">
                                <div>上传图片</br>1920*300</div>
                            </div>
                        </el-upload>
                    </div>
                </div>
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">模板：</div>
                    <div class="DigItem">
                        <div class="FuJianPos" v-for="(item, i) in NewData.mb_url" @click="LockUrl(item)">
                            {{item.name}}
                            <i v-if="Type != 'Lock'" class="NavIcon el-icon-circle-close FuJianAbs"
                                @click.stop="RemoveFile(i)"></i>
                        </div>
                        <el-upload action="none" :show-file-list="false" :http-request="(res) => UploadFlie(res, 'Moldel',)">
                            <el-button v-throttle class="BgColor" size="small" type="info">上传模板</el-button>
                        </el-upload>
                    </div>
                </div>
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">状态：</div>
                    <el-switch v-model="NewData.status" active-color="#13ce66" inactive-color="#ddd" 
                        :active-value="1" :inactive-value="0"/>
                </div>
            </div>
            <el-tabs type="border-card" v-model="Act" v-if="NewData.blon">
                <el-tab-pane label="申请须知配置" name="SQXZ">
                      <div class="XyHead">
                          <Toolbar style="border-bottom: 1px solid #ccc" :editor="SQeditor" :defaultConfig="toolbarConfig"/>
                          <Editor style="height: 300px; overflow-y: hidden;" v-model="NewData.sq_xz" :defaultConfig="editorConfig" @onCreated="SQCreated" />
                      </div>
                </el-tab-pane>
                <el-tab-pane label="评审须知配置" name="PSXZ">
                      <div class="XyHead">
                          <Toolbar style="border-bottom: 1px solid #ccc" :editor="PSeditor" :defaultConfig="toolbarConfig"/>
                          <Editor style="height: 300px; overflow-y: hidden;" v-model="NewData.ps_xz" :defaultConfig="editorConfig" @onCreated="PSCreated"/>
                      </div>
                </el-tab-pane>
              <el-tab-pane label="保密协议配置" name="BMXY">
                    <div class="XyHead">
                        <Toolbar style="border-bottom: 1px solid #ccc" :editor="BMeditor" :defaultConfig="toolbarConfig"/>
                        <Editor style="height: 300px; overflow-y: hidden;" v-model="NewData.xieyi" :defaultConfig="editorConfig" @onCreated="BMCreated"/>
                    </div>
              </el-tab-pane>
            </el-tabs>
            <div slot="footer">
                <el-button v-throttle size="small" @click="$Tools.ResetData(NewData)">取消</el-button>
                <el-button v-throttle class="BgColor" size="small" type="primary" @click="Suc">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { Editor, Toolbar} from '@wangeditor/editor-for-vue'
    export default {
        name: "AdminSysType",
        props: {
            visible: {
                type: Boolean,
                default: false,
            },
            rowData: {
                type: Object,
                default: {},
            },
        },
        components: { Editor, Toolbar },
        data() {
            return{
                loading:false,
                SearchVal:"",
                StateVal:"",
                Page:1,
                PageSize:10,
                Totol:0,
                Data: [],
                SeleId:[],
                localRowData: {},
                Type:'Add',
                iconArr:[],
                NewData:{
                    blon:false,
                    system_id:"",
                    id:"",
                    name:"",
                    icon:"",
                    cot:"",
                    status:0,
                    shenhe:0,
                    lxr_name:"",
                    lxr_phone:"",
                    kv_url:"",
                    mb_url:[],
                    sq_xz:"",   
                    ps_xz:"",
                    xieyi:"", 
                },
                Act:"SQXZ",
                SQeditor: null,
                PSeditor: null,
                BMeditor: null,
                toolbarConfig: {
                  excludeKeys: ['uploadVideo']
                }
            }
        },
        watch: {
            rowData: {
                immediate: true, 
                handler(newVal) {
                    this.localRowData = JSON.parse(JSON.stringify(newVal));
                    this.GetData()
                }
            }
        },
        methods: {
            GetData(){
                this.loading = true;
                this.$get('/admin/system_sub/index',{
                    keyword:this.SearchVal,
                    page:this.Page,
                    page_size:this.PageSize,
                    status:this.StateVal,
                    system_id:this.localRowData.id,
                }).then(res=>{
                    this.loading = false;
                    if(res){
                        this.Data = res.data.list;
                        this.Totol = res.data.total;
                    }
                })
            },
            SeleChange(val) {
                this.SeleId = val.map(item => item.id);
            },
            ToggleDig(row){
                this.Act="SQXZ";
                this.$Tools.ResetData(this.NewData)
                if(row!='Add'){
                    this.Type='Edi';
                    this.NewData.id = row.id;
                    this.NewData.name = row.name;
                    this.NewData.icon = row.icon;
                    this.NewData.cot = row.cot;
                    this.NewData.status = row.status;
                    this.NewData.shenhe = row.shenhe;
                    this.NewData.lxr_name = row.lxr_name;
                    this.NewData.lxr_phone = row.lxr_phone;
                    this.NewData.kv_url = row.kv_url;
                    this.NewData.mb_url = row.mb_url;
                    this.NewData.sq_xz = row.sq_xz;
                    this.NewData.ps_xz = row.ps_xz;
                    this.NewData.xieyi = row.xieyi;
                }else{
                    this.Type='Add';
                    this.NewData.sq_xz = "";
                    this.NewData.ps_xz = "";
                    this.NewData.xieyi = "";
                }
                this.NewData.system_id = this.localRowData.id,
                this.NewData.blon = true;
            },
            Suc(){
                var url = this.Type=='Add'?'/admin/system_sub/save':'/admin/system_sub/update';
                this.$post(url,this.NewData).then(res=>{
                    if(res){
                        this.$message.success("操作成功");
                        this.ReSetPage();
                        this.$Tools.ResetData(this.NewData)
                    }
                })
            },
            ToggleSysType(row){
                this.$post('/admin/system_sub/toggleStatus',{
                    ids:[row.id],
                    status:row.status,
                }).then(res=>{
                    if(res){
                        this.$message.success("修改成功!");
                        this.GetData();
                    }
                })
            },
            LockUrl(url){
                var str = "";
                if(url.indexOf('http') == 0){
                    str = url;
                }else{
                    str = this.$Tools.ServeUrl()+url;
                }
                window.open(str)
            },
            RemoveFile(i){
                this.NewData.mb_url.splice(i,1);
            },
            UploadFlie(row,type){
                var file = row.file;
                const loading = this.$loading({lock: true,text: 'Loading',spinner: 'el-icon-loading',background: 'rgba(0, 0, 0, 0.7)'});
                const MAX_SIZE = 100 * 1024 * 1024 * 5;
                const fileSize = file.size;
                if (fileSize > MAX_SIZE) {
                    this.$message.error(`文件大小超出限制！最大支持500M，当前文件大小：${(fileSize / 1024 / 1024).toFixed(2)}M`);
                    return;
                }
                try {
                    var fd = new FormData()
                    fd.append('file',file);
                    this.$post("/common/upload/image",fd,{
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        }
                    }).then((res)=>{
                        loading.close();
                        if(type == "File"){
                            this.NewData.kv_url  = res.data.url;
                        }else{
                            this.NewData.mb_url.push({
                                url:res.data.url,
                                name:res.data.original_name
                            });
                        }
                    })
                } catch (error) {
                    loading.close();
                }
            },
            async handleEditorUpload(file, insertFn) {
                const fd = new FormData()
                fd.append('file', file)
                try {
                    await this.$post("/common/upload/image", fd,{
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        }
                    }).then((res)=>{
                        insertFn(this.$Tools.ServeUrl() + res.data.url)
                    })
                } catch (err) {
                    this.$message.error('网络异常，上传失败')
                }
            },
            SQCreated(editor) {
                this.SQeditor = Object.seal(editor)
                const uploadConf = editor.getMenuConfig('uploadImage')
                uploadConf.server = "#"
                uploadConf.customUpload = async (file, insertFn) => {
                    await this.handleEditorUpload(file, insertFn)
                }
                this.$get('/admin/expert_field/xieyi',{}).then(res=>{
                    if(res){
                        this.EditorCont = res.data.content;
                    }
                })
            },
            PSCreated(editor) {
                this.PSeditor = Object.seal(editor)
                const uploadConf = editor.getMenuConfig('uploadImage')
                uploadConf.server = "#"
                uploadConf.customUpload = async (file, insertFn) => {
                    await this.handleEditorUpload(file, insertFn)
                }
                this.$get('/admin/expert_field/xieyi',{}).then(res=>{
                    if(res){
                        this.EditorCont = res.data.content;
                    }
                })
            },
            BMCreated(editor) {
                this.BMeditor = Object.seal(editor)
                const uploadConf = editor.getMenuConfig('uploadImage')
                uploadConf.server = "#"
                uploadConf.customUpload = async (file, insertFn) => {
                    await this.handleEditorUpload(file, insertFn)
                }
                this.$get('/admin/expert_field/xieyi',{}).then(res=>{
                    if(res){
                        this.EditorCont = res.data.content;
                    }
                })
            },
            Delete(id){
                var Ids = id != "" ? [id] : this.SeleId;
                this.$confirm("此操作将永久删除项目, 是否继续?", "提示", {
                    type: "warning"
                }).then(() => {
                    this.$del('/admin/system_sub/delete', {
                        ids: Ids,
                    }).then(res => {
                        if (res) {
                            this.$message.success(res.msg);
                            this.GetData();
                        }
                    })
                })
            },
            CloseDig() {
                if (this.SQeditor) this.SQeditor.destroy()
                if (this.PSeditor) this.PSeditor.destroy()
                if (this.BMeditor) this.BMeditor.destroy()
                this.SQeditor = null
                this.PSeditor = null
                this.BMeditor = null
                this.$emit("cancel");
            },
            SizeChange(val){
                this.PageSize = val;
                this.GetData();
            },
            PageChange(val){
                this.Page = val;
                this.GetData();
            },
            ReSetPage(){
                this.Page = 1;
                this.GetData();
            },
        },
    };
</script>

<style scoped>
    .MaxHei {
        max-height: 650px;
        overflow-y: auto;
    }
    .DigItem .DigItemTit{
        width: 120px;
    }
    .FuJianPos {
        position: relative;
        padding: 6px 10px;
        border: 1px solid #ddd;
        border-radius: 3px;
        margin-right: 10px;
        text-align: center;
        cursor: pointer;
        margin-bottom: 5px;
    }
    .FuJianAbs {
        position: absolute;
        top: -5px;
        right: -15px;
        font-size: 14px;
        color: #d51938;
    }
    .ImgPos {
        position: relative;
        width: 70px;
        height: 70px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #ddd;
        border-radius: 3px;
        margin-right: 10px;
        cursor: pointer;
    }
    .XyHead{
        border:1px solid #ccc;
        margin-bottom: 10px;
    }
</style>